import React, {useRef} from 'react';
import { SelectField, MenuItem } from "@curves/ui-base";
import useEmployeeScheduleApi from '@apis/useEmployeeScheduleApi';
import { isEmpty } from '@util/utils';

const EmployeeScheduleCircuitMatter = React.forwardRef((props, ref) => {
    const { postEmployeeScheduleCircuitDataApi } = useEmployeeScheduleApi();
    const { option, sourceData: sourceDataProp = {}, scheduleDate, scheduleTime } = props;
    const { employeeID = '', scheduleID = 0 } = sourceDataProp;
    const itemIdRef = useRef(null);

    const handleOnChange = (e, node, value) => {
        let params = {
            scheduleDate: scheduleDate,
            scheduleTime: scheduleTime,
            employeeID: value,
            scheduleID: scheduleID,
        };
        if(!isEmpty(itemIdRef.current)) {
            params.scheduleID = itemIdRef.current;
        };
        postCircuitApi(params);
    };

    const postCircuitApi = async (params) => {
        const res = await postEmployeeScheduleCircuitDataApi(params);  
        if (res) {
            itemIdRef.current = res;
        }  
        
    };

    return (
        <SelectField defaultValue={employeeID || '0'} onChange={handleOnChange}>
            <MenuItem value="0">
                <em>未安排</em>
            </MenuItem>
            {option.map(({ text, value, disabled }) => (
                <MenuItem value={value} disabled={disabled} key={`${value}-${text}`}>
                    {text}
                </MenuItem>
            ))}
        </SelectField>
    );
});

export default EmployeeScheduleCircuitMatter;
